import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { ANAGRAFICHE_MAX_LENGTH } from "src/app/pages/search/search.constants"

export const search_form_keys: IFormKey[] = [
    {
        id: 'ndg-field',
        controlName: 'ndg',
        label: 'NDG',
        css: 'col-3'
    }
]

export const advanced_search_form_keys: IFormKey[] = [
    {
        id: 'policy-id-field',
        controlName: 'policyId',
        label: 'Numero polizza',
        css: 'col-4'
    },
    {
        id: 'contract-id-field',
        controlName: 'contractId',
        label: 'Numero contratto',
        css: 'col-4'
    },
    {
        id: 'tax-code-field',
        controlName: 'taxCode',
        label: 'Codice fiscale',
        css: 'col-4',
        uppercase: true
    },
    {
        id: 'name',
        controlName: 'name',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'surname',
        controlName: 'surname',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'birth-date',
        controlName: 'birthDate',
        label: 'Data di nascita',
        css: 'col-4',
        type: 'DATEPICKER'
    },
    {
        id: 'vat-code-field',
        controlName: 'vatCode',
        label: 'P. IVA',
        css: 'col-4'
    },
    {
        id: 'business-name',
        controlName: 'businessName',
        label: 'Ragione sociale',
        css: 'col-4'
    }
]

export const simple_search_form_template = {
    ndg: null
}

export const advanced_search_form_template = {
    policyId: null,
    contractId: null,
    taxCode: null,
    vatCode: null,
    businessName: null,
    name: null,
    surname: null,
    birthDate: null,
    limit: ANAGRAFICHE_MAX_LENGTH
}

export const simple_search_form_validators = {
    ndg: [Validators.required]
}

export const advanced_search_form_validators = {
    taxCode: [Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)]
}

export interface ISearchEvent {
    type?: TSearchType;
    rawForm?: any;
    skipList?: boolean;
    skipSubjectList?: boolean;
    element?: any;
    simulateOperation?: boolean;
}

export enum ESearchType {
    BASIC = 'BASIC',
    ADVANCED = 'ADVANCED'
}

export type TSearchType = keyof typeof ESearchType;
